export default "__VITE_ASSET__CqOGT7pS__"